const STORAGE_KEY = 'yubumarket_consent_preferences_v1';

const DEFAULT_PREFERENCES = {
  essential: true,
  analytics: false,
  marketing: false,
  updatedAt: null,
};

function sanitizePreferences(value) {
  return {
    essential: true,
    analytics: Boolean(value?.analytics),
    marketing: Boolean(value?.marketing),
    updatedAt: value?.updatedAt || null,
  };
}

export function getConsentPreferences() {
  if (typeof window === 'undefined') return DEFAULT_PREFERENCES;

  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return DEFAULT_PREFERENCES;
    return sanitizePreferences(JSON.parse(raw));
  } catch {
    return DEFAULT_PREFERENCES;
  }
}

export function hasSavedConsentPreferences() {
  if (typeof window === 'undefined') return false;
  return Boolean(window.localStorage.getItem(STORAGE_KEY));
}

export function saveConsentPreferences(preferences) {
  if (typeof window === 'undefined') return DEFAULT_PREFERENCES;

  const nextPreferences = sanitizePreferences({
    ...preferences,
    updatedAt: new Date().toISOString(),
  });

  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(nextPreferences));
  window.dispatchEvent(new CustomEvent('yubumarket-consent-updated', { detail: nextPreferences }));

  if (nextPreferences.marketing && typeof window.__ymLoadMetaPixel === 'function') {
    window.__ymLoadMetaPixel();
  }

  return nextPreferences;
}

export function acceptAllConsentPreferences() {
  return saveConsentPreferences({
    essential: true,
    analytics: true,
    marketing: true,
  });
}

export function acceptEssentialOnlyConsentPreferences() {
  return saveConsentPreferences({
    essential: true,
    analytics: false,
    marketing: false,
  });
}

export function subscribeToConsentPreferences(callback) {
  if (typeof window === 'undefined') return () => {};

  const handler = (event) => callback(event.detail || getConsentPreferences());
  window.addEventListener('yubumarket-consent-updated', handler);
  return () => window.removeEventListener('yubumarket-consent-updated', handler);
}

